import React, { Component } from 'react';
import { increment, decrement, reset } from './actions';
import {connect} from "react-redux";

class Counter extends Component {
  constructor(props) {
	  super(props);
	  this.state = {
		total: 0,
        lastUpdateTime: new Date()
	  };
    }

  componentDidMount() {
    this.getTotal();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.counter > prevProps.counter 
    && (new Date() - this.state.lastUpdateTime) > 10*1000) {
        this.setState({
            lastUpdateTime: new Date()
        });
        this.getTotal();
    }
  }

  getTotal() {
    fetch("/api/counters/counter")
    .then((response) => response.json())
    .then((responseData) => {
      this.setState({
          total: responseData.count+1
      });
    });
  }

  render() {
    return (
	<div class="w3-container w3-padding-large">
		<h2>Counter: {this.props.counter}</h2>
        {this.state.total > 0 && <h3>Total: {this.state.total}</h3>}
		<div class="w3-padding-16">
			  <button class="w3-margin-right w3-button w3-circle w3-green" style={{"width": "50px"}} onClick={this.props.incrementCounter}>+</button>
			  <button class="w3-margin-right w3-button w3-circle w3-teal" style={{"width": "50px"}} onClick={this.props.decrementCounter} >-</button>
			  <button class="w3-button w3-red" onClick={this.props.resetCounter} >Reset</button>
		</div>
	</div>
    );
  }
}

const mapStateToProps = currentState => {
    return {
        counter: currentState.value,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        incrementCounter: () => dispatch(increment()),
        decrementCounter: () => dispatch(decrement()),
        resetCounter: () => dispatch(reset()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Counter);

//	buttonPressed = (e) => {
//	  this.setState((prevState) => {
//		  if (e  === "increase") {
//			return {counter: prevState.counter + 1}
//		  } else if (e  === "decrease" && this.state.counter > 0)  {
//			  return {counter: prevState.counter - 1} 
//		  } else {
//			  return {counter: 0}
//		  }
//	  });
//	}    
//  render() {
//    return (
//	<div class="w3-container w3-padding-large">
//		<h2>Counter: {this.state.counter}</h2>
//		<div class="w3-padding-16">
//			  <button class="w3-margin-right w3-button w3-circle w3-green" onClick={() => this.buttonPressed("increase")}>+</button>
//			  <button class="w3-margin-right w3-button w3-circle w3-teal" onClick={() => this.buttonPressed("decrease")} >-</button>
//			  <button class="w3-button w3-red" onClick={() => this.buttonPressed("reset")} >Reset</button>
//		</div>
//	</div>
//    );
//  }
//}
//export default Counter;


// WEBPACK FOOTER //
// ./src/Counter.js